// This houses the whole game data
//Levels
import CyberPunkCity_Src from "./Assets/Levels/CyberpunkCity.jpg";


// Characters
// CyberPunkCity
import Cc_Src from "./Assets/Characters/Cyberpunk/cc.png";
import Diana_Src from "./Assets/Characters/Cyberpunk/diana.png";
import Dio_Src from "./Assets/Characters/Cyberpunk/dio.png";
import Gwyndolin_Src from "./Assets/Characters/Cyberpunk/gwyndolin.png";
import Hellboy_Src from "./Assets/Characters/Cyberpunk/hellboy.png";
import Leeloo_Src from "./Assets/Characters/Cyberpunk/leeloo.png";
import Neo_Src from "./Assets/Characters/Cyberpunk/neo.png";
import Predator_Src from "./Assets/Characters/Cyberpunk/predator.png";
import Ryuk_Src from "./Assets/Characters/Cyberpunk/ryuk.png";
import Spiderman_Src from "./Assets/Characters/Cyberpunk/spiderman.png";

const game = {
    level: [
      {
        name: "CyberPunk City",
        image: CyberPunkCity_Src,
        mode: [
          {
            difficulty: "easy",
            characters: [
              {
                name: "Diana",
                title: "Seven Deadly Sins",
                image: Diana_Src,
                xCoordinate: 80,
                yCoordinate: 80,
                isFound: false,
              },
              {
                name: "Gywndolin",
                title: "Dark Souls",
                image: Gwyndolin_Src,
                xCoordinate: 21,
                yCoordinate: 97,
                isFound: false,
              },
              {
                name: "Leelo",
                title: "The Fifth Element",
                image: Leeloo_Src,
                xCoordinate: 85,
                yCoordinate: 28,
                isFound: false,
              },
              {
                name: "Neo",
                title: "The Matrix",
                image: Neo_Src,
                xCoordinate: 41,
                yCoordinate: 60,
                isFound: false,
              },
              {
                name: "Ryuk",
                title: "Death Note",
                image: Ryuk_Src,
                xCoordinate: 17,
                yCoordinate: 46,
                isFound: false,
              },
            ],
          },
          {
            difficulty: "hard",
            characters: [
              {
                name: "C.C",
                title: "Code Geass",
                image: Cc_Src,
                xCoordinate: 70,
                yCoordinate: 42,
                isFound: false,
              },
              {
                name: "Dio Brando",
                title: "JoJo's Bizarre",
                image: Dio_Src,
                xCoordinate: 23,
                yCoordinate: 86,
                isFound: false,
              },
              {
                name: "Hellboy",
                title: "Hellboy",
                image: Hellboy_Src,
                xCoordinate: 9,
                yCoordinate: 95,
                isFound: false,
              },
              {
                name: "Predator",
                title: "The Predator",
                image: Predator_Src,
                xCoordinate: 95,
                yCoordinate: 67,
                isFound: false,
              },
              {
                name: "Spiderman",
                title: "The Spiderman",
                image: Spiderman_Src,
                xCoordinate: 65,
                yCoordinate: 93,
                isFound: false,
              },
            ],
          },
        ],
      },
    ],
};
export default game;